module.exports = require('postcss-font-family-system-ui/src/main.mjs').default;



//////////////////
// WEBPACK FOOTER
// ./build/pffsu-monkeypatch.js
// module id = bZbn
// module chunks = 1